import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const attributes = [
  { attribute: 'size', type: "'xs' | 's' | 'm' | 'l' | 'xl'", default: "'m'", description: 'The size of the spacer.' },
  { attribute: 'className', type: 'string', default: "''", description: 'Additional class names.' },
  { attribute: 'style', type: 'React.CSSProperties', default: 'undefined', description: 'Inline styles.' },
];

const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
  { columnId: 'attribute', renderHeaderCell: () => 'Attribute', renderCell: (item) => item.attribute },
  { columnId: 'type', renderHeaderCell: () => 'Type', renderCell: (item) => <code>{item.type}</code> },
  { columnId: 'default', renderHeaderCell: () => 'Default', renderCell: (item) => <code>{item.default}</code> },
  { columnId: 'description', renderHeaderCell: () => 'Description', renderCell: (item) => item.description },
];

const codeExample = `
import UQSpacer from '@uniqconsulting/ui/components/spacer';

<div>
  <div>Above</div>
  <UQSpacer size="xs" />
  <div>XS Spacer</div>
  <UQSpacer size="s" />
  <div>S Spacer</div>
  <UQSpacer size="m" />
  <div>M Spacer</div>
  <UQSpacer size="l" />
  <div>L Spacer</div>
  <UQSpacer size="xl" />
  <div>XL Spacer</div>
</div>
`;

const SpacerDemoPage = () => (
  <>
    <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Spacer']} />
    <h1>UQSpacer Demo</h1>
    <UQSpacer size="m" />

    <h2>Description</h2>
    <p>
      <code>UQSpacer</code> is used to add vertical spacing between elements. You can control the amount of space with the <code>size</code> prop.
    </p>
    <UQSpacer size="m" />

    <h2>Attributes</h2>
    <UQSpacer size="s" />
    <UQDataGrid
      items={attributes}
      columns={attributeColumns}
      sortable={false}
      selectionMode="none"
      rowLines
    />
    <UQSpacer size="m" />

    <h2>Examples</h2>
    <UQSpacer size="s" />
    <div style={{ background: '#222', padding: '1rem', color: '#fff', borderRadius: 8 }}>
      <div>Above</div>
      <UQSpacer size="xs" />
      <div>XS Spacer</div>
      <UQSpacer size="s" />
      <div>S Spacer</div>
      <UQSpacer size="m" />
      <div>M Spacer</div>
      <UQSpacer size="l" />
      <div>L Spacer</div>
      <UQSpacer size="xl" />
      <div>XL Spacer</div>
    </div>
    <UQSpacer size="m" />

    <h2>Code Example</h2>
    <UQCode code={codeExample.trim()} enableCopy />
  </>
);

export default SpacerDemoPage;